<template>
    <div :id="id">
        <div v-if="length < 8">
            <InputDigitsRaw
                v-model="state"
                :error="error"
                :focus="focus"
                :length="length"
                :disabled="disabled"
                @submit="emit('submit')"
            />
        </div>
        <InputText
            v-else
            v-model="state"
            :label="label"
            :error="error"
            :focus="focus"
            :disabled="disabled"
            @submit="emit('submit')"
        />
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import InputDigitsRaw from 'widget-components/components/InputDigitsRaw'
import InputText from 'widget-components/components/InputText'
import marked from '../../utilities/marked'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    modelValue: [String, null],
    label: String,
    length: {
        type: [Number, String],
        default: 5,
    },
    error: {
        type: [String, Boolean, null],
        default: null,
    },
    focus: Boolean,
    disabled: Boolean,
    blockPath: Array,
})

const label = computed(() => marked(props.label))

const emit = defineEmits(['update:modelValue', 'submit'])

const model = computed(() => props.modelValue)
const state = ref(model.value)

watch(state, (val) => {
    emit('update:modelValue', val)
})

watch(model, (val) => {
    if (val !== state.value) state.value = val
})

const disabled = computed(() => props.disabled)
const length = computed(() => +props.length)
</script>
